import { FC } from "react";
import { NavLink } from "react-router";
import classNames from "classnames";

import { ERoutes } from "../../../../constants/routes";

import styles from "./AgencySection.module.css";

const AgencySection: FC = () => {
  return (
    <nav className={styles["agency"]} aria-label="Agency">
      <p className={styles["agency__title"]}>Agency</p>
      <NavLink
        className={({ isActive }) =>
          classNames(styles["agency__item"], isActive && styles["is-active"])
        }
        to={ERoutes.Agency}
      >
        Clients
      </NavLink>
    </nav>
  );
};

export default AgencySection;
